export default __webpack_public_path__ + "static/swim-7bd2a8cc4695c4ac9326b3d221ad880e.jpg";